export default __webpack_public_path__ + "static/media/wa-5748.3ad1f895.jpg";